import type { ButtonProps } from '@sravni/react-design-system/lib/Button';
import { useState } from 'react';

import type { TOffer } from 'shared/types/TRankingService';

import type { TPledgeEstateFields } from 'entities/pledgeEstateForm';

import { useSendOffer } from 'features/OfferControls';
import { OfferButton } from 'features/OfferControls/ui/OfferButton/OfferButton';

import { OfferControlsTexts } from '../../OfferControls.texts';

import { PledgeEstatePopup } from './PledgeEstatePopup';

interface ISendOfferProps {
  offer: TOffer;
  buttonProps?: ButtonProps;
}

export const PledgeEstate = ({ offer, buttonProps }: ISendOfferProps) => {
  const { onClick: onClickProp, ...otherButtonProps } = buttonProps || {};
  const { sendOffer, isLoading } = useSendOffer('PledgeEstate');
  const [isShowPopup, setIsShowPopup] = useState(false);

  const onSubmit = async (data: TPledgeEstateFields) => {
    await sendOffer(offer, { pledgeEstateData: data });
    setIsShowPopup(false);
  };

  const onShowPopup = async () => {
    setIsShowPopup(true);
  };
  const onClosePopup = () => {
    setIsShowPopup(false);
  };

  return (
    <>
      <OfferButton
        {...otherButtonProps}
        variant="primary"
        color="dark"
        onClick={(event) => {
          event.stopPropagation();
          onShowPopup();
          onClickProp?.(event);
        }}
        loading={isLoading || isShowPopup}
      >
        {offer?.additionalInfo?.buttonText || OfferControlsTexts.sendOfferLabel}
      </OfferButton>
      <PledgeEstatePopup
        onSubmit={onSubmit}
        isSubmitting={isLoading}
        isShowPopup={isShowPopup}
        onClosePopup={onClosePopup}
      />
    </>
  );
};
